import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { MenuItem } from "@/types/menu.type";
import SidebarComponent from "./SidebarComponent.vue";
import securityService from "@/service/security.service";
import { AppRole, AppType } from "@/types/app.type";
import { onMounted, reactive, computed } from "vue";
import { RootState } from "@/types/state.type";
import { useStore } from "vuex";
import { getAvailableRoutes } from "@/service/user.service";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let items: MenuItem[] = reactive([]);
if (process.env.NODE_ENV === "development") {
  items = reactive([
    {
      icon: "el-icon el-icon-home fas",
      index: "/support",
      title: "menu.home",
      disabled: false,
    },
    {
      icon: "el-icon el-icon-eye fas",
      index: "/support/samplingPoints",
      title: "menu.samplingPoints",
      disabled: false,
    },
    {
      icon: "el-icon el-icon-bell fas",
      index: "/support/alerts",
      title: "menu.alerts",
      disabled: false,
    },
    {
      icon: "el-icon el-icon-upload fas",
      index: "/support/import",
      title: "menu.importData",
      disabled: false,
    },
    //Galeria
    // {
    //   icon: "el-icon el-icon-image fas",
    //   index: "/support/gallery",
    //   title: "menu.gallery",
    //   disabled: false,
    // },
    // {
    //   icon: "el-icon el-icon-chart-area fas",
    //   index: "/support/GraphClient",
    //   title: "menu.graphData",
    //   disabled: false,
    // },
    {
      icon: "el-icon el-icon-file-export fas",
      index: "/support/report",
      title: "menu.report",
      disabled: false,
    },
  ]);
} else if (process.env.NODE_ENV === "pre") {
  items = reactive([
    {
      icon: "el-icon el-icon-home fas",
      index: "/support",
      title: "menu.home",
      disabled: false,
    },
    {
      icon: "el-icon el-icon-eye fas",
      index: "/support/samplingPoints",
      title: "menu.samplingPoints",
      disabled: false,
    },
    {
      icon: "el-icon el-icon-bell fas",
      index: "/support/alerts",
      title: "menu.alerts",
      disabled: false,
    },
    {
      icon: "el-icon el-icon-upload fas",
      index: "/support/import",
      title: "menu.importData",
      disabled: false,
    },
    {
      icon: "el-icon el-icon-file-export fas",
      index: "/support/report",
      title: "menu.report",
      disabled: false,
    },
  ]);
} else {
  items = reactive([
    {
      icon: "el-icon el-icon-home fas",
      index: "/support",
      title: "menu.home",
      disabled: false,
    },
    {
      icon: "el-icon el-icon-eye fas",
      index: "/support/samplingPoints",
      title: "menu.samplingPoints",
      disabled: false,
    },
    {
      icon: "el-icon el-icon-bell fas",
      index: "/support/alerts",
      title: "menu.alerts",
      disabled: false,
    },
    {
      icon: "el-icon el-icon-upload fas",
      index: "/support/import",
      title: "menu.importData",
      disabled: false,
    },
    {
      icon: "el-icon el-icon-file-export fas",
      index: "/support/report",
      title: "menu.report",
      disabled: false,
    },
  ]);
}

const store = useStore<RootState>();
const username = computed(() => {
  return store.state.auth.user?.email || "";
});

onMounted(async () => {
  const canAdmin = securityService.canAccessToApp(AppType.ADMIN);
  const canSupport = securityService.canAccessToApp(AppType.SUPPORT);
  const canStations = securityService.canAccessToApp(AppType.STATIONS);
  const canProcessTracking = securityService.canAccessToApp(AppType.PROCESS_TRACKING);
  const canAccessIssueMonitoring = securityService.canAccessToApp(AppType.ISSUE_MONITORING);

  if (canSupport && !canStations && !canAdmin && !canProcessTracking && !canAccessIssueMonitoring) {
    items.shift();
  }
  if (store.state.auth.user?.id) {
    let userRoutes = await getAvailableRoutes(store.state.auth.user.id);
    if (userRoutes && Array.isArray(userRoutes) && userRoutes.length > 0) {
      // if (userRoutes ) {
      items.forEach((item) => {
        item.disabled = !userRoutes.includes(item.index);
      });
    }
  }

  const allowUsersSatellital = [
    "user01@example.com",
    "user00@example.com",
    "marisa.inf@aquacorp.es",
    "ivgoma.inf@aquacorp.es",
    "mahube.cal@aquacorp.es",
    "mavafi.inf@aquacorp.es",
    "pablo.perez@aquacorp.es",
    "pablo.gonzalez@aquacorp.es",
    "pcrespo@miteco.es",
    "at_sggidph1@miteco.es",
  ];

  if (allowUsersSatellital.includes(username.value)) {
    items.push({
      icon: "el-icon el-icon-satellite-dish fas",
      index: "/support/satelite",
      title: "menu.satellite",
      disabled: false,
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SidebarComponent, { items: _unref(items) }, null, 8, ["items"]))
}
}

})